import styled from '@/styles';

export const Separator = styled('div', {
  width: '100%',

  border: '1px solid $colors$neutralLightest',
});
